import { DraftReturnSchema } from "@redotech/redo-model/draft-return/draft-return";
import { PendingReturnItemSchema_ } from "@redotech/redo-model/draft-return/draft-return-items";
import { zExt } from "@redotech/rpc/ext";
import { z } from "zod/v4";

export const AddItemPendingItemSchema = PendingReturnItemSchema_.omit({
  id: true,
  manualReview: true,
  flagged: true,
  returnReason: true,
  returnOptions: true,
  selectedReturnOption: true,
  // Don't pass in the flow from the frontend. It will be set on the server.
  flow: true,
});

export type AddItemPendingItem = z.infer<typeof AddItemPendingItemSchema>;

export const addReturnItem = {
  name: "addReturnItem" as const,
  input: z.object({
    draftReturnId: zExt.objectId(),
    previousPendingItemId: z.string().optional(),
    pendingItem: AddItemPendingItemSchema,
  }),
  output: z.object({ draftReturn: DraftReturnSchema }),
};
